/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import "./styles.css";

/* Library imports */
import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import TextField from "@material-ui/core/TextField";
import { TextareaAutosize } from "@material-ui/core";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";

import { styled } from "@material-ui/core/styles";

/* Component imports */
import * as UtilityLg from "../../../UtilityLg";
import ConstantsLg from "../../../ConstantsLg";

/*** End Imports ***/

export default class TextboxOutline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      textBoxValue: "",
    };
  }

  componentDidMount() {}

  componentWillMount() {
    const { textBoxValue } = this.props;
    this.setState({
      textBoxValue: textBoxValue,
    });
  }

  validateManually = (value) => {
    const { pattern } = this.props;
    let obj = {
      hasValue: value || (value && value.toString()) === "0" ? true : false,
      isValid: false,
    };

    if (pattern.test(value)) {
      obj.isValid = true;
    }
    return obj;
  };

  onChangeTextField = (event) => {
    const { pattern } = this.props;
    let value = event.target.value;
    let obj = this.validateManually(value);
    this.props.onChange(value, obj);
    this.setState({
      hasError: false,
    });
  };

  onBlurInput = () => {
    const { textBoxValue, isRequired } = this.props;
    let obj = this.validateManually(textBoxValue);
    if (isRequired) {
      if (obj.isValid && obj.hasValue) {
      } else {
        this.setState({
          hasError: true,
        });
      }
    } else {
      if (textBoxValue) {
        if (obj.isValid) {
        } else {
          this.setState({
            hasError: true,
          });
        }
      } else {
      }
    }
  };

  onFocusInput = () => {
    this.setState({
      hasError: false,
    });
  };

  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.props.onEnterClick();
    }
  };

  render() {
    const {
      textBoxId,
      textBoxLabel,
      textBoxType,
      textBoxName,
      textBoxAutocomplete,
      textBoxMargin,
      textBoxVariant,
      textBoxValue,
      helperText,
      isRequired,
      isAutoFocus,
      isDisabled,
    } = this.props;

    const { hasError } = this.state;

    const TextFieldBG = withStyles({
      notchedOutline: {
        background: "transparent",
      },
      focused: {
        notchedOutline: {
          background: "transparent",
        },
      },
    })(TextField);

    return (
      <TextFieldBG
        id={textBoxId}
        label={textBoxLabel}
        type={textBoxType}
        name={textBoxName}
        autoComplete={textBoxAutocomplete}
        margin={textBoxMargin}
        variant={textBoxVariant}
        value={textBoxValue}
        onChange={this.onChangeTextField}
        helperText={helperText}
        error={hasError}
        fullWidth={true}
        autoFocus={isAutoFocus}
        defaultValue={textBoxValue}
        required={isRequired}
        onBlur={this.onBlurInput}
        onFocus={this.onFocusInput}
        onKeyDown={this.keyPress}
        disabled={isDisabled}
      />
    );
  }
}

TextboxOutline.defaultProps = {
  textBoxId: "outlined-email-input",
  textBoxLabel: "Email ID",
  textBoxType: "email",
  textBoxName: "email",
  textBoxAutocomplete: "email",
  textBoxMargin: "normal",
  textBoxVariant: "outlined",
  textBoxValue: "",
  // helperText: "this is helper text",
  isRequired: false,
  isAutoFocus: false,
  isDisabled: false,
};

TextboxOutline.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/core/TextBoxOutline/TextBoxOutline.js